import React, { useEffect, useState } from 'react';
import { AuthForm } from './components/AuthForm';
import { Dashboard } from './components/Dashboard';
import { supabase } from './lib/supabase';
import { BrowserRouter } from 'react-router-dom';
import type { User } from '@supabase/supabase-js';

function App() {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    // Get initial session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
    });

    // Listen for auth changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <div className="min-h-screen bg-slate-50">
      {user ? (
        <BrowserRouter>
          <Dashboard user={user} />
        </BrowserRouter>
      ) : (
        <AuthForm />
      )}
    </div>
  );
}

export default App;